<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-toolbar dark color="primary pl-2 pr-2" dense>
        <v-toolbar-title
          >Restaurant History</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon dark @click="exist()">
          <v-icon>cancel</v-icon>
        </v-btn>
      </v-toolbar>
    </v-col>
    <v-col cols="12" md="12">
      <v-row no-gutters>
        <v-col
          v-for="(item, index) in historyList"
          :key="index"
          cols="6"
          md="3"
        >
          <v-card class="ma-1" outlined>
            <v-card-title class="primary white--text">
              <v-icon color="white" class="mr-2">event</v-icon>
              <h5>{{ item.date }}</h5>
            </v-card-title>
            <v-row no-gutters class="ml-2 mr-2">
              <v-col cols="12" md="12" class="red--text">
                <h4>{{item.title}}</h4>
              </v-col>
              <v-col cols="5" md="3">
                Id  
              </v-col>
              <v-col cols="7" md="9">
                : {{item.historyId}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="3">
                User  
              </v-col>
              <v-col cols="7" md="9">
                : {{item.userName}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="3">
                Status  
              </v-col>
              <v-col cols="7" md="9" class="blue--text">
                : {{item.saveOrupdate}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
<v-col cols="5" md="3">
                Profile  
              </v-col>
              <v-col cols="7" md="9">
                : {{item.comDto.companyName}} 
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="3">
                Address  
              </v-col>
              <v-col cols="7" md="9">
                <h5>: {{item.comDto.address}} </h5>
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="3">
                Phone No  
              </v-col>
              <v-col cols="7" md="9">
                <h5>: {{item.comDto.phoneNo}} </h5>
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="3">
                Hot Line  
              </v-col>
              <v-col cols="7" md="9">
                <h5>: {{item.comDto.hotLine}} </h5>
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="3">
               Way 
              </v-col>
              <v-col cols="7" md="9">
                <h5>: {{item.comDto.waySuppervisor}} </h5>
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="3">
                Operation  
              </v-col>
              <v-col cols="7" md="9">
                <h5>: {{item.comDto.operationHead}} </h5>
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="3">
                Finance  
              </v-col>
              <v-col cols="7" md="9">
                <h5>: {{item.comDto.finance}} </h5>
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="3">
                Email
              </v-col>
              <v-col cols="7" md="9">
                <h5>: {{item.comDto.email}} </h5>
              </v-col>
              <v-col cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="5" md="3">
                Logo  
              </v-col>
              <v-col cols="7" md="9">
                <h5>: {{item.comDto.logo}} </h5>
              </v-col>
              </v-row>
              </v-card>
              </v-col>
              </v-row>
    </v-col>
  </v-row>
  
</template>
<script>
import historyService from "../service/HistoryService";
export default {
  data: () => ({
    historyList:[]
  }),
  props: {indexCom:Number},
  mounted: function () {
     this.getHistory();
  },
  methods: {
    getHistory:function(){
      historyService
          .getHistoryByCompany(this.userId)
          .then((response) => {
            console.log(response);
            this.historyList.splice(0);
            this.historyList.push(...response);
          })
          .catch(err => {
              this.$swal("Failed", err.response.data.message, "error");
          });
    },
    exist: function () {
      this.$emit("closeDialog");
    },
  },
  watch: {
    indexCom:function(){
      this.getHistory();
    }
  },
  components: {},
};
</script>
<style scoped>
</style>